<template >


<section>
     <!-- Content Header (Page header) -->
     <section class="content-header">
        <h1>
           PAPELETAS
           <small>Percy</small>
        </h1>
        <ol class="breadcrumb">
           <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
           <li class="active">Papeletas</li>
        </ol>
     </section>
     <!-- Main content -->
     <section class="content">
        <div class="row">
        <!-- left column -->
          <div class="col-md-12">
             <!-- general form elements -->
             <div class="box box-primary">
                <br>
                <!-- /.box-header -->
                <!-- form start -->
                <form class="" action="index.html" method="post">
                      <div class="col-md-12">

                          <router-link
                            to="/papeletas/nueva"
                            class="btn btn-facebook"
                          >
                            <i class="fa fa-plus"></i> Nuevo
                          </router-link>


                         <!--
                          <button class="btn btn-light">
                           <i class="fa fa-trash"> Eliminar</i>
                         </button>
                      -->

                      </div>

                </form>

                <br>



             </div>
             <!-- /.box -->
          </div>
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="content table-responsive table-full-width" >
               <table class="table table-condensed">
                  <thead>
                     <tr class="active">
                        <td>#</td>
                        <th>TIPO DE PAPELETA</th>
                        <th>FEC.INICIO</th>
                        <th>FEC.TERMINO.</th>
                        <th>MOTIVO</th>
                        <th>FEC.REGISTRO</th>
                        <th>AUTORIZACIÓN</th>
                        <th>SINC.RELOJ.</th>
                        <th>Acción</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr v-for="(papeleta,index) in papeletas" :key="index">
                        <td>{{index + 1}}</td>
                        <td data-title="CÓDIGO">{{papeleta.descripcion}}</td>
                        <td data-title="NÚMERO">{{papeleta.fechaInicio}}</td>
                        <td data-title="DEMANDANTE">{{papeleta.fechaFinal}}</td>
                        <td data-title="DEMANDADO">{{papeleta.observacion}}</td>
                        <td data-title="COLEGIADO">{{papeleta.registerDate}}</td>
                        <td data-title="INGRESO">{{papeleta.estado}}</td>
                        <td data-title="INGRESO">{{papeleta.estadoReloj}}</td>
                        <td data-title="VER">


                        <span rel="tooltip" title="Ver" data-state="primary" data-placement="right"
                        class="fa fa-search btn btn-success"
                        @click="selectPapeleta(papeleta)"
                        ></span>


                        <span rel="tooltip" title="Editar" data-state="primary"
                        data-placement="right" class="fa fa-pencil btn btn-facebook"
                        @click="goToEdit(papeleta)"></span>


                          <!--

                        <router-link :to="'/papeletas/'+ papeleta.idpapeleta +'/subir'">
                          <span rel="tooltip" title="Subir" data-state="primary" data-placement="right" class="fa fa-file-pdf-o btn btn-facebook" style="background:black;"></span>
                        </router-link>
-->


                        <span rel="tooltip" title="Editar" data-state="primary"
                        data-placement="right" class="fa fa-trash btn btn-facebook"
                        @click="goToDelete(papeleta)"></span>



                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>



          </div>
        </div>
      </div>
     </section>
  </section>


</template>
<script>



import config from './../../config';
  import { mapGetters, mapActions, mapState } from 'vuex';

  export default {
    name : 'PapeletasSalida',
    data(){
      return {
        alg : [1,3,5,6,7,3]
      }
    },
    computed: {

      papeletas() {
        return this.$store.getters.papeletas
      }
    },

    mounted(){
      console.log('iniciando mounted');
      this.$store.dispatch('loadPapeletas','100255');
      console.log('Finalizando');






    },

    methods  : {

      selectPapeleta(papeleta){
          console.log('selecciona papaleta ' , papeleta);
          this.$store.dispatch('selectPapeleta',papeleta);

          this.$router.push('/papeletas/'+papeleta.idpapeleta)

      },
      goToEdit(papeleta){
        this.$store.dispatch('selectPapeleta',papeleta);
        this.$router.push('/papeletas/'+ papeleta.idpapeleta + '/editar')
      },

      goToDelete(papeleta){
        console.log('ELIMINAMOS ESTA PAPALETA ', papeleta);
        swal({
            title: "¿Estás seguro?",
            text: "",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {

              axioss.get(config.serverURI  + 'aplicaciones/elimp/'+papeleta.idpapeleta)
                .then(function(response){
                  console.log('resultado',response);

                  let data = response.data;
                    if(data == 0){
                        this.$store.dispatch('loadPapeletas','100255');
                        swal('Se eliminó correctamente')
                    }else{
                        swal('No se pudo eliminar.','','error');
                    }
                })



              swal("Eliminado con éxito.", {
                icon: "success",
              });


            } else {

              //this.$swal("");
            }
          });

      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/PapeletasSalida.vue